import { NgModule } from '@angular/core';
import { AcceptTermsDialogPage } from './accept-terms-dialog.page';
import { SharedModule } from '@app/shared/shared.module';
import { CookiesInfoComponent } from './cookies-info/cookies-info.component';

@NgModule({
  imports: [
    SharedModule
  ],
  declarations: [
    AcceptTermsDialogPage,
    CookiesInfoComponent
  ],
})
export class AcceptTermsDialogPageModule {}
